export default "__VITE_ASSET__e2397926__"